var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"SimpleLoader spinner-wrapper",class:{ fullPage: _vm.fullPage }},[_c('ios-sync-icon',{staticClass:"spinner",attrs:{"w":"40","h":"40"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }